'use client';

import Link from 'next/link';

import StrapiBackgroundImage from '@web-landing/components/StrapiImages/StrapiBackgroundImage';

import {TAutoupdatePage} from '@web-landing/strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import styles from './IntroBanner.module.scss';

type Props = Pick<
  TAutoupdatePage,
  'banner_buttonText' | 'intro_backgroundImage' | 'intro_title'
>;

export const IntroBanner = ({
  banner_buttonText,
  intro_backgroundImage,
  intro_title,
}: Props) => {
  const onClick = () => {
    logTmrEvent(EVENTS.downloadClick, {
      pageURL: document.location.pathname,
      location: 'top',
    });
  };

  return (
    <div className={styles.intro__wrapper}>
      <StrapiBackgroundImage
        imageData={intro_backgroundImage}
        className={styles.intro}
      >
        <h1 className={styles.intro__title}>{intro_title}</h1>
        <Link
          onClick={onClick}
          className={styles.intro__button}
          href="/instruction"
        >
          {banner_buttonText}
        </Link>
      </StrapiBackgroundImage>
    </div>
  );
};
